import { render } from "./AppBaseView.vue?vue&type=template&id=27b1eb6a&scoped=true"
import script from "./AppBaseView.vue?vue&type=script&lang=js"
export * from "./AppBaseView.vue?vue&type=script&lang=js"

import "./AppBaseView.vue?vue&type=style&index=0&id=27b1eb6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b1eb6a"]])

export default __exports__